<template>
  <el-tag
    v-if="!!commandsStatus"
    size="medium" :type="cssClass"
  >{{ commandStatusLabel }}
  </el-tag>
</template>

<script>
export default {
  name: "hc-command-status",
  props: ["commandsStatus"],

  computed: {
    cssClass() {
      switch (this.commandsStatus) {
        case "PROCESSING":
          return "warning";
        case "COMPLETE":
          return "success";
        case "USUALLY":
          return "info";
        default:
          return "";
      }
    },

    commandStatusLabel() {
      switch (this.commandsStatus) {
        case "PROCESSING":
          return "Đang xử lý";
        case "COMPLETE":
          return "Hoàn thành";
        case "USUALLY":
          return "CV hằng ngày";
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/ketluan/hc-command-status.vue